import { DialogActionsProps } from '@material-ui/core/DialogActions';
import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';
import styles from './StyledDialog.module.scss';
import classNames from 'classnames';

export class StyledDialogActions extends React.Component<DialogActionsProps & { tighter?: boolean }> {
    public static muiName = 'DialogActions';

    public render() {
        const { children, tighter, ...otherProps } = this.props;
        const dialogClasses = {
            root: classNames(styles.dialogActions, { [styles.tighter]: tighter })
        };

        if (React.Children.count(children))
            return (
                <DialogActions {...otherProps} classes={dialogClasses}>
                    {children}
                </DialogActions>
            );

        return null;
    }
}
